export default __webpack_public_path__ + "static/media/Virtual4-mobi.dcd91b80.webp";